export interface JackpotState {
    jackpotData: any;
    loading: boolean;
    error: null | string;
}


export enum JackpotActionTypes {
    FETCH_JACKPOT_DATA = "FETCH_JACKPOT_DATA",
    FETCH_JACKPOT_DATA_SUCCESS = "FETCH_JACKPOT_DATA_SUCCESS",
    FETCH_JACKPOT_DATA_ERROR = "FETCH_JACKPOT_DATA_ERROR",
}

export type JackpotAction =
    | { type: JackpotActionTypes.FETCH_JACKPOT_DATA }
    | { type: JackpotActionTypes.FETCH_JACKPOT_DATA_SUCCESS; payload: any[] }
    | { type: JackpotActionTypes.FETCH_JACKPOT_DATA_ERROR; payload: string };

